import { useMemo } from 'react';
import Tabs from 'components/Table/Tabs';
import { useLocation, useNavigate } from 'react-router-dom';
import { CallOutline, PhonePortraitOutline, Wifi } from 'react-ionicons';
import { usePermissions } from 'hooks/usePermissions';
import clsx from 'clsx';
import { useFeatureFlags } from 'feature-flags';

enum TabsEnum {
  'access' = 0,
  'mobility' = 1,
  'voice' = 2,
}

const NavigationTabs = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { flags } = useFeatureFlags();

  const { isSuperAdmin, hasPermission } = usePermissions({
    forGraniteUser: true,
  });

  const tabs = useMemo(() => {
    return [
      {
        icon: (
          <Wifi
            width="24px"
            height="24px"
            color="currentColor"
            style={{ fill: 'currentColor' }}
          />
        ),
        title: 'Access',
        onClick: () => navigate('access'),
        className: '!pb-6 !border-b',
      },
      {
        icon: (
          <PhonePortraitOutline
            width="24px"
            height="24px"
            color="currentColor"
          />
        ),
        title: 'Mobility',
        onClick: () => navigate('mobility?type=SMART%2520PHONE'),
        className: '!pb-6 !border-b',
        disabled: !(flags.MOBILITY_ACCESS ? hasPermission : isSuperAdmin),
      },
      {
        icon: <CallOutline width="24px" height="24px" color="currentColor" />,
        title: 'Voice',
        onClick: () => {},
        className: clsx('!pb-6 !border-b', !isSuperAdmin && '!hidden'),
        disabled: true,
      },
    ];
  }, [isSuperAdmin, navigate, hasPermission, flags]);

  const activeTab = useMemo(() => {
    if (pathname.includes('/mobility')) return TabsEnum.mobility;
    if (pathname.includes('/voice')) return TabsEnum.voice;
    return TabsEnum.access;
  }, [pathname]);

  return (
    <>
      <Tabs
        variant="medium"
        className="mt-2 max-w-[320px] flex-1 overflow-x-auto scrollbar-thin scrollbar-track-transparent scrollbar-thumb-stroke-base-subdued xs:max-w-full"
        withUnderline={false}
        defaultActiveTab={activeTab}
        tabs={tabs}
        type="accent-primary"
        activeTab={activeTab}
      />
    </>
  );
};

export default NavigationTabs;
